import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { useStores } from 'src/stores/useStores';
import './MarketFilter/styles.css';
import Select from './Select';

interface IMarketFilterProps {
    total?: number;
}

const MarketFilter = (props: IMarketFilterProps) => {
    const { marketStore } = useStores();

    const [collection, setCollection] = useState<string>(marketStore.filter.collection);
    
    let initialSortKey = 'default';
    if (marketStore.sortingField === 'buyOutPrice') {
        initialSortKey = marketStore.sortingDirection === 'asc' ? 'cheap' : 'expensive';
    }
    if (marketStore.sortingField === 'bids') {
        initialSortKey = marketStore.sortingDirection === 'asc' ? 'cheapBids' : 'expensiveBids';
    }
    const [sorting, setSorting] = useState<string>(initialSortKey);

    function sortOn<T> (arr: T[], prop: keyof T) {
        arr.sort (
            (a, b) => {
                if (a[prop] < b[prop]){
                    return -1;
                } else if (a[prop] > b[prop]){
                    return 1;
                } else {
                    return 0;
                }
            }
        );
    }

    const collectionOptions = [
        { title: "All collections", key: "all" },
        { title: "Sign Art", key: "3PPgeYTWMRZ7S7jSLpnVuKKB9r6XuDk3ndC_signArt" },
        { title: "Waves ducks", key: "3P3pDosq4GCwfJkvq4yqKvvoTwmoqc9qPmo_ducks" },
        { title: "Eagles", key: "eagles" },
        { title: "Waves Lands", key: "3PCW9q51iwFiaDZB8SSRgc7jqjYgTgQy5T3_WavesLands" },
        { title: "Pluto Eagles", key: "3P5d8a1H2m2zFQakhaaow3uDE77UYLGd89v_PLUTO EAGLES" },
        { title: "Bored Ania", key: "3PMki5sHBsQb4KgDknbUwsL3YgxaCzaZnCJ_ania|3PKVgd6ds1xervK6bPXbEHBqg8ibTcf5HZk_ania" },
        { title: "Puzzle Pool Artefact", key: "3PFkgvC9y6zHy64zEAscKKgaNY3yipiLqbW_Puzzle Pool Artefact"},
        { title: "Puzzle Gang Avangard", key: "3P5CQkvk8Pu6rGP3Qav4Lwskwa8pLhNwTbR_Puzzle Gang Avangard" },
        { title: "Puzzle Eagles", key: "3P6peovAkVN3px6Zuv8y2noTWHFM4R5Wjj8_Puzzle Eagles" },
        { title: "Clef", key: "3P4m4beJ6p1pMPHqCQMAXEdquUuXJz72CMe_Clef genesis songs"},
        { title: "Charity collection", key: "3P3iV85eXfkcA3Dd13EpZBYvs1vkKX6AYEN_erics charity collection"},
        { title: "MonsterHunt", key: '3PHKDCQScvSPHvdCUeucFkx5Q1xMURA9kbr_MonsterHunt Alpha Monsters'},
        { title: "Puzzle Ducks", key: '3PGGSiLuwGmm7ChfjDrmEZBd6HxQJn8N1NM_Puzzle Ducks'},
        // { title: "WavesPunks", key: '3PD1sd55PYzmGUrQ896Qt3uvdbtgjCVpajE_WavesPunks Zombie|3PD1sd55PYzmGUrQ896Qt3uvdbtgjCVpajE_WavesPunks|3PD1sd55PYzmGUrQ896Qt3uvdbtgjCVpajE_WavesPunks Memaliens'},
        { title: "The beginning of the Puzzle", key: '3PKHFX6W4aAr1e1b8MUTz5HmdWVUcjWhgY4_The beginning of the Puzzle'},
        { title: "DAO Dragons", key: '3P975LUuqc7uBPiSxp3nemf2FZh62zfirSh_Market DAO Dragons'},
        { title: 'Burn Baby Burn', key: '3PEtLVxDT8mxAh1SDAn8m7JTGNkdpkaFxBk_Burn Baby Burn'}
    ];

    sortOn(collectionOptions, 'title');

    const sortingOptions = [
        { title: "Recently listed", key: "default" },
        { title: "Popular", key: "popular" },
        { title: "Сheap first", key: "cheap" },
        { title: "Expensive first", key: "expensive" },
        { title: "Сheapest bids", key: "cheapBids" },
        { title: "Expensive bids", key: "expensiveBids" }
    ];

    //Recently listed

    return (
        <div className='puzzle-marketFilter'>
            <div className='puzzle-marketFilter__body'>
                <Select
                    options={collectionOptions}
                    selected={collectionOptions.filter(item => item.key === collection)[0]}
                    minWidth='200px'
                    onSelect={({ key }) => {
                        setCollection(key);
                        marketStore.setCollectionFilter(key);
                        marketStore.find();
                    }} />

                {
                    props.total ? <div className='puzzle-marketFilter__total'>{props.total} items</div> : ''
                }

                <div className='puzzle-marketFilter__sorting'>
                    <div className='puzzle-marketFilter__sortingLabel'>Sort by</div>
                    <Select
                        options={sortingOptions}
                        selected={sortingOptions.filter(item => item.key === sorting)[0]}
                        onSelect={({ key }) => {
                            switch(key) {
                                case 'default':
                                    marketStore.setSortingByTime('desc');
                                    break;
                                case 'cheap':
                                    marketStore.setSortingByPrice();
                                    break;
                                case 'expensive':
                                    marketStore.setSortingByPrice('desc');
                                    break;
                                case 'popular':
                                    marketStore.setSortingByLike('desc');
                                    break;
                                case 'cheapBids':
                                    marketStore.setSortingByBid();
                                    break;
                                case 'expensiveBids':
                                    marketStore.setSortingByBid('desc');
                                    break;
                            }
                            setSorting(key);
                            marketStore.find();
                        }} />
                </div>
            </div>
        </div>
    )
}

export default observer(MarketFilter);
